export default {
  btnName: 'Profil',
  options: {
    info: 'Profil',
    trips: 'Mes trajets',
    logout: 'Déconnexion',
  },
};
